import React, { useState, useCallback, useEffect } from 'react';
import { RestAddress } from '../../../hooks/useAddress';
import { Box } from '../../Box';
import { AmazonShippingAndPaymentPreview } from '../AmazonShippingAndPaymentPreview';
import { AmazonShippingAndPaymentForm } from '../AmazonShippingAndPaymentForm';

type Props = {
  theme?: 'box' | 'simple';
  address?: RestAddress;
  addressId?: number | null;
  isFilled: boolean;
  readOnly?: boolean;
  isSaving?: boolean;
  onSwitchToCard: () => Promise<void>;
  onSubmit?: () => Promise<void>;
  onModeChange?: (mode: Mode) => void;
};

export enum Mode {
  Resting,
  Editing
}

export const AmazonShippingAndPayment: React.FC<Props> = ({
  theme = 'simple',
  address,
  addressId,
  isFilled,
  readOnly,
  isSaving = false,
  onSwitchToCard,
  onSubmit,
  onModeChange
}) => {
  const [mode, setMode] = useState(isFilled || readOnly ? Mode.Resting : Mode.Editing);

  const handleCancel = useCallback(
    () => (isFilled ? setMode(Mode.Resting) : onSwitchToCard()),
    [isFilled, onSwitchToCard]
  );

  useEffect(() => {
    onModeChange?.(mode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  return (
    <Box borderless={theme === 'simple' || mode === Mode.Editing}>
      {mode === Mode.Resting && (
        <AmazonShippingAndPaymentPreview
          address={address}
          addressId={addressId}
          readOnly={readOnly}
          onEdit={() => setMode(Mode.Editing)}
          onSwitchToCard={onSwitchToCard}
          isSaving={isSaving}
        />
      )}
      {mode === Mode.Editing && (
        <AmazonShippingAndPaymentForm
          onClose={() => setMode(Mode.Resting)}
          onCancel={handleCancel}
          onSubmit={onSubmit}
        />
      )}
    </Box>
  );
};
